export default "__VITE_ASSET__a061e210__"